/*
 * @Author: your name
 * @Date: 2020-12-04 17:36:41
 * @LastEditTime: 2021-07-13 10:06:13
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /pub-app/src/main.js
 */
import Vue from 'vue';
import App from './App.vue';
import router from './router/index';
import store from './store/index';
import HllMUI from 'hll-m-ui';
import http from './commons/http';
import { sendEvent } from './commons/monitor.js';
// 全局工具函数
import Tools from './commons/tools/global';
import iosInputBack from './mixins/ios-input-back';
// 全局公共css
import './assets/css/public.less';
import './assets/css/vant-reset.less';
// 自定义指令
import directives from './directives';
import track from '@/commons/track';
import config from '@/commons/config';
// 神策配置
import SensorsConfig from './commons/sensors';
import {
  HttpProxy,
} from '@hll/secure-transfer-sdk';
import { EncryptKeys } from './EncryptKeys.js';
import coupeSDK from './coupe.js';

function defaultEncryptStrategy() {
  console.log('defaultEncryptStrategy open');
  proxy.enableEncryptMode();
}

const proxy = HttpProxy.getInstance({
  enableDebug: true,
  encryptQueryKeys: EncryptKeys,
  onMessage: (data) => {
    // 📬 监听加解密状态变化（可选）
    console.log(`${data.operation} ${data.success ? '✅成功' : '❌失败'}`);
  },
});

// 默认策略
defaultEncryptStrategy();

// 调用 fetch 获取数据
coupeSDK.fetch().then(data => {
  if (data.disableEncrypt) {
    // coupe 关闭加密
    console.log('coupe 关闭加密');
    proxy.enablePlainMode();
  } else {
    console.log('coupe 开启加密');
    proxy.enableEncryptMode();
  }
}).catch(() => {
  console.log('coupe 失败，使用默认策略');
  // 默认策略
  defaultEncryptStrategy();
});

// 引入神策
const sensors = require('./commons/sensorsdata.min.js');
// const ENV = process.env.NODE_ENV === 'production' ? '' : '-dev';
// if (config.envType === '-stg' || config.envType === '-pre') {
//   const VConsole = require('vconsole'); // 移动端调试工具
//   // eslint-disable-next-line
//   new VConsole();
// }

if (process.env.NODE_ENV === 'development') {
  Vue.config.devtools = true;
}

if (!window.sensors) {
  window.sensors = sensors;
  sensors.init({
    // server_url: `https://uba${ENV}.huolala.cn/sa?project=default`,
    server_url: config.saurl,
    heatmap: {
      // 是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
      // 需要 JSSDK 版本号大于 1.7
      clickmap: 'not_collect',
      // 是否开启触达注意力图，默认 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
      // 需要 JSSDK 版本号大于 1.9.1
      scroll_notice_map: 'not_collect'
    }
  });
  sensors.quick('isReady', function() {
    sensors.login(sensors.quick('getAnonymousID'));
  });
}

sensors.quick('autoTrack', {
  platForm: 'H5'
});

Vue.config.productionTip = process.env.NODE_ENV !== 'production';

Vue.use(HllMUI);
Vue.use(Tools);
Vue.use(iosInputBack);
Vue.use(track);
Vue.use(directives);

// 添加全局方法
Vue.prototype.$axios = http;
Vue.prototype.$http = http;
Vue.prototype.$sensors = SensorsConfig;

if (!window.closeWebView) {
  // 修复客户端异常报错
  window.closeWebView = () => {
    console.log('closeWebView');
  };
}

window.addEventListener('unhandledrejection', event => {
  sendEvent('@unhandledrejection', event, event && event.toString && event.toString());
  event && event.preventDefault && event.preventDefault();
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
